import { render, staticRenderFns } from "./MedicalEvaluationPreBout.vue?vue&type=template&id=2db1d67c&scoped=true&"
import script from "./MedicalEvaluationPreBout.vue?vue&type=script&lang=js&"
export * from "./MedicalEvaluationPreBout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1d67c",
  null
  
)

export default component.exports